import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Alert, Table, Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import ReportHeader from '../ReportsHeader';
import './style.scss';
import ReportForm from '@Components/Reports/ReportForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

const { Column, ColumnGroup } = Table;

/**
 *
 */
class ReportTable extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      selectedCategory: '',
      inventoryReportColumns: [
        {
          title: 'Product',
          width: '240px',
          render: (record) => (
            <Fragment>
              <Link target="_blank" to={`/inventory/product/view/${record?.product_sku_id}`}>
                <H3Text text={record?.internal_sku_code} />
              </Link>
              <H3Text text={`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''} ${record?.product_sku_name}`?.trim()} className="prod-table__text" />
              {record?.product_category_info?.category_path && (
                <Tooltip
                  overlay={(
                    <div
                      style={{
                        color: 'rgb(0, 0, 0)',
                        fontSize: '12px',
                        fontWeight: '500',
                        padding: '2px',
                      }}
                    >
                      {record.product_category_info.category_path.join(' / ')}
                    </div>
                  )}
                  color="rgb(234, 242, 254)"
                >
                  {' '}
                  {/* Tooltip wrapping the div */}
                  <div
                    className="category__status_tag"
                    style={{ backgroundColor: '#3aa5a6' }}
                  >
                    {/* Displaying only the last category name with ellipsis if path is long */}
                    {record?.product_category_info ? (
                 `.../${record?.product_category_info?.product_category_name}`
                    ) : (
                      ''
                    )}
                  </div>
                </Tooltip>
              )}
            </Fragment>
          ),
        },
        {
          title: 'Opening Stock',
          children: [
            {
              title: 'Quantity',
              render: (record) => (
                <H3Text text={`${record?.opening_stock_qty || 0} ${record?.unit?.toProperCase()}`} />
              ),
            },
            {
              title: 'Unit Cost',
              render: (record) => (
                <H3Text text={`${this.props.MONEY(record?.opening_stock_unit_cost || 0)} `} />
              ),
            },
            {
              title: 'Value',
              render: (record) => (
                <H3Text text={this.props.MONEY(record?.opening_stock_value || 0)} />
              ),
            },
          ],
        },
        {
          title: 'Inwards',
          render: (record) => (
            <H3Text text={`${Number(record?.inwards_stock || 0)} ${record?.unit?.toProperCase()}`} />
          ),
        },
        {
          title: 'Outwards',
          render: (record) => (
            <H3Text text={`${Number(record?.outwards_stock || 0)} ${record?.unit?.toProperCase()}`} />
          ),
        },
        {
          title: 'Closing Stock',
          children: [
            {
              title: 'Quantity',
              render: (record) => (
                <H3Text text={`${record?.closing_stock_qty || 0} ${record?.unit?.toProperCase()}`} />
              ),
            },
            {
              title: 'Unit Cost',
              render: (record) => (
                <H3Text text={`${this.props.MONEY(record?.opening_stock_unit_cost || 0)} `} />
              ),
            },
            {
              title: 'Value',
              render: (record) => (
                <H3Text text={this.props.MONEY(record?.closing_stock_value || 0)} />
              ),
            },
          ],
        },
      ],
      allProductsData: [],
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && (Number(Helpers.getValueFromUrl('startDate')) !== state.startDateMomentEpoch
      || Number(Helpers.getValueFromUrl('endDate')) !== state.endDateMomentEpoch
      || Helpers.getValueFromUrl('interval') !== state.selectedInterval
      || Helpers.getValueFromUrl('tenant') !== state.selectedTenant
      || Helpers.getValueFromUrl('department_id') !== state.selectedDepartment
      || Helpers.getValueFromUrl('costing_method') !== state.selectedMethod
        || Helpers.getValueFromUrl('category') !== state.selectedCategory

    )) {
      const {
        firstSubUrl, secondSubUrl, user, getReports, type,
      } = props;
      if (Helpers.getValueFromUrl('startDate') && Helpers.getValueFromUrl('endDate') && Helpers.getValueFromUrl('tenant') && Helpers.getValueFromUrl('interval')) {
        getReports(firstSubUrl, secondSubUrl, user?.tenant_info?.org_id, Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id, Helpers.getValueFromUrl('startDate'), Helpers.getValueFromUrl('endDate'), type, 1, 50, Helpers.getValueFromUrl('department_id'), '', Helpers.getValueFromUrl('costing_method') || 'last_purchase_price', '', Helpers.getValueFromUrl('category'));
        return {
          ...state,
          isUserReady: true,
          startDateMomentEpoch: Number(Helpers.getValueFromUrl('startDate') || dayjs().startOf('month').valueOf()),
          endDateMomentEpoch: Number(Helpers.getValueFromUrl('endDate') || dayjs().endOf('month').valueOf()),
          selectedInterval: Helpers.getValueFromUrl('interval') || 'this_month',
          selectedTenantIds: (Helpers.getValueFromUrl('tenant')?.split(',')?.length > 1 ? 'All' : Number(Helpers.getValueFromUrl('tenant'))) || user?.tenant_info?.tenant_id,
          selectedTenant: Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id,
          selectedDepartment: Helpers.getValueFromUrl('department_id'),
          selectedMethod: Helpers.getValueFromUrl('costing_method') || 'last_purchase_price',
          selectedCategory: Helpers.getValueFromUrl('category'),
          allProductsData: props.inventoryReport?.data,
        };
      }
    }
    return state;
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource = () => {
    const {
      type, purchaseByVendor, purchaseByProduct, purchaseLedger, inventoryAdjustment, inventorySummary, stockTransfer, inventoryReport, salesLedger, salesByCustomer, salesByProduct, stockInward, stockOutward,
    } = this.props;
    if (type === 'purchase_by_vendor' && purchaseByVendor?.tenant_purchase?.length) {
      const tempData = [];
      const operationData = purchaseByVendor?.tenant_purchase;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'purchase_by_product' && purchaseByProduct?.tenant_purchase?.length) {
      const tempData = [];
      const operationData = purchaseByProduct?.tenant_purchase;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'purchase_ledger' && purchaseLedger?.purchase_ledger?.length) {
      const tempData = [];
      const operationData = purchaseLedger?.purchase_ledger;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'inventory_adjustment' && inventoryAdjustment?.inventory_adjustment?.length) {
      const tempData = [];
      const operationData = inventoryAdjustment?.inventory_adjustment;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'inventory_summary' && inventorySummary?.inventory?.length) {
      const tempData = [];
      const operationData = inventorySummary?.inventory;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'stock_transfer_report' && stockTransfer?.data?.length) {
      const tempData = [];
      const operationData = stockTransfer?.data;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'inventory_report' && inventoryReport?.data?.length) {
      const tempData = [];
      const operationData = inventoryReport?.data;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'stock_inward_report' && stockInward?.stock_inward?.length) {
      const tempData = [];
      const operationData = stockInward?.stock_inward;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }

      return tempData;
    }
    if (type === 'stock_outward_report' && stockOutward?.stock_outward?.length) {
      const tempData = [];
      const operationData = stockOutward?.stock_outward;
      for (let i = 0; i < operationData.length; i++) {
        tempData.push({
          ...operationData[i],
          key: uuidv4(),
        });
      }
      return tempData;
    }
    if (type === 'sales_ledger' && salesLedger?.data?.length) {
      const tempData = [];
      const operationData = salesLedger?.data;
      for (let j = 0; j < operationData?.length; j++) {
        for (let i = 0; i < operationData[j].sales_ledger?.length; i++) {
          tempData.push({
            ...operationData[j]?.sales_ledger?.[i],
            key: uuidv4(),
          });
        }
      }
      return tempData;
    }
    if (type === 'sales_by_customer' && salesByCustomer?.data?.length) {
      const tempData = [];
      const operationData = salesByCustomer?.data;
      for (let j = 0; j < operationData?.length; j++) {
        for (let i = 0; i < operationData[j].tenant_sales?.length; i++) {
          tempData.push({
            ...operationData[j]?.tenant_sales?.[i],
            key: uuidv4(),
          });
        }
      }
      return tempData;
    }
    if (type === 'sales_by_product' && salesByProduct?.data?.length) {
      const tempData = [];
      const operationData = salesByProduct?.data;
      for (let j = 0; j < operationData?.length; j++) {
        for (let i = 0; i < operationData[j].tenant_sales?.length; i++) {
          tempData.push({
            ...operationData[j]?.tenant_sales?.[i],
            key: uuidv4(),
          });
        }
      }
      return tempData;
    }
    return [];
  }

  /**
   *
   * @param {object} props
   */
  render() {
    const {
      type, getReportsLoading, columnsData, getReports,
      firstSubUrl, secondSubUrl, user, inventoryReport, stockInward, stockOutward, getDownloadReportsLoading,
    } = this.props;
    const {
      page, startDateMomentEpoch, endDateMomentEpoch, selectedTenant, selectedDepartment, selectedMethod, selectedCategory, inventoryReportColumns, selectedTenantIds,
    } = this.state;
    return (
      <Fragment>
        {type !== 'inventory_report' && (
          <ReportHeader
            type={type}
            firstSubUrl={firstSubUrl}
            secondSubUrl={secondSubUrl}
            setPage={() => this.setState({ page: 1 })}
          />
        )}
        <div className="reports-table-container">
          {type === 'inventory_report' && (
            <React.Fragment>
              <ReportForm
                title={(
                  <div>
                    <FontAwesomeIcon icon={faFileCsv} />
                    &nbsp;
                    Opening and Closing Stock Register
                  </div>
                )}
                type={type}
                firstSubUrl={firstSubUrl}
                secondSubUrl={secondSubUrl}
              />
            </React.Fragment>
          )}
          {(type === 'stock_outward_report' || type === 'stock_inward_report')
            && (
              <React.Fragment>
                <Table
                  loading={getReportsLoading || getDownloadReportsLoading}
                  bordered
                  showHeader
                  size="small"
                  scroll={{ y: 'calc(100dvh - 230px)' }}
                  columns={columnsData}
                  dataSource={this.getDataSource()}
                  pagination={{
                    total: this.getDataSource()?.length === 50 ? (page > 1 && this.getDataSource()?.length < 50 ? (((page - 1) * 50) + this.getDataSource()?.length) : (page * 50) + 1) : ((50 * (page - 1)) + this.getDataSource()?.length),
                    pageSize: 50,
                    showSizeChanger: false,
                    onChange: (currentPage) => {
                      this.setState({ page: currentPage });
                      getReports(firstSubUrl, secondSubUrl, user?.tenant_info?.org_id, selectedTenant, startDateMomentEpoch, endDateMomentEpoch, type, currentPage, 50, selectedDepartment, '', selectedMethod, '', selectedCategory);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => (
                      <div className="reports-table__footer">
                        <H3Text text={`Showing ${((page - 1) * 50) + 1} - ${this.getDataSource()?.length + ((page - 1) * 50)} Records`} className="reports-table__footer-text" />
                        <Alert
                          showIcon
                          type="info"
                          message="You can only view 50 records at a time. Please download the report to view all records"
                        />
                      </div>
                    ),
                  }}
                />
              </React.Fragment>
            )}
          {' '}
          {(type !== 'inventory_report' && type !== 'stock_outward_report' && type !== 'stock_inward_report')
            && (
              <React.Fragment>
                <Table
                  loading={getReportsLoading || getDownloadReportsLoading}
                  bordered
                  showHeader
                  size="small"
                  scroll={{ y: 'calc(100dvh - 230px)', x: 'max-content' }}
                  columns={columnsData}
                  dataSource={this.getDataSource()}
                  pagination={{
                    total: this.getDataSource()?.length === 50 ? (page > 1 && this.getDataSource()?.length < 50 ? (((page - 1) * 50) + this.getDataSource()?.length) : (page * 50) + 1) : ((50 * (page - 1)) + this.getDataSource()?.length),
                    pageSize: 50,
                    showSizeChanger: false,
                    onChange: (currentPage) => {
                      this.setState({ page: currentPage });
                      getReports(firstSubUrl, secondSubUrl, user?.tenant_info?.org_id, selectedTenant, startDateMomentEpoch, endDateMomentEpoch, type, currentPage, 50, selectedDepartment, '', selectedMethod, '', selectedCategory);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => (
                      <div className="reports-table__footer">
                        <H3Text text={`Showing ${((page - 1) * 50) + 1} - ${this.getDataSource()?.length + ((page - 1) * 50)} Records`} className="reports-table__footer-text" />
                        <Alert
                          showIcon
                          type="info"
                          message="You can only view 50 records at a time. Please download the report to view all records"
                        />
                      </div>
                    ),
                  }}
                />
              </React.Fragment>
            )}

        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  getDownloadReportsLoading: ReportReducers.getDownloadReportsLoading,
  purchaseByVendor: ReportReducers.purchaseByVendor,
  inventorySummary: ReportReducers.inventorySummary,
  inventoryAdjustment: ReportReducers.inventoryAdjustment,
  purchaseByProduct: ReportReducers.purchaseByProduct,
  purchaseLedger: ReportReducers.purchaseLedger,
  stockTransfer: ReportReducers.stockTransfer,
  getReportsLoading: ReportReducers.getReportsLoading,
  inventoryReport: ReportReducers.inventoryReport,
  salesLedger: ReportReducers.salesLedger,
  salesByCustomer: ReportReducers.salesByCustomer,
  salesByProduct: ReportReducers.salesByProduct,
  stockInward: ReportReducers.stockInward,
  stockOutward: ReportReducers.stockOutward,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});
const mapDispatchToProps = (dispatch) => ({
  getReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category) => dispatch(
    ReportActions.getReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category),
  ),
});

ReportTable.propTypes = {
  columnsData: PropTypes.any,
  purchaseByVendor: PropTypes.any,
  firstSubUrl: PropTypes.string,
  secondSubUrl: PropTypes.string,
  getReports: PropTypes.func,
  type: PropTypes.any,
  user: PropTypes.any,
  inventorySummary: PropTypes.any,
  inventoryAdjustment: PropTypes.any,
  purchaseByProduct: PropTypes.any,
  stockTransfer: PropTypes.any,
  purchaseLedger: PropTypes.any,
  inventoryReport: PropTypes.any,
  getReportsLoading: PropTypes.bool,
  stockInward: PropTypes.any,
  stockOutward: PropTypes.any,
  salesLedger: PropTypes.any,
  salesByCustomer: PropTypes.any,
  salesByProduct: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportTable));
